import { Alert, Grid, Group, Loader, Anchor, Stack } from '@mantine/core';
import { Link, useParams } from 'react-router';
import { useUserOverview } from '../hooks/useUserDetail';
import { LeftRail } from './user-detail/LeftRail';
import { UsagePanel } from './user-detail/UsagePanel';
import { Timeline } from './user-detail/Timeline';
import type { LinkedMember } from './Feedback';

export function UserDetail() {
  const { id } = useParams<{ id: string }>();
  const overview = useUserOverview(id!);

  if (overview.isLoading) return <Loader />;
  if (overview.isError) {
    return (
      <Alert color="red" title="Couldn't load this user">
        {overview.error.message}
      </Alert>
    );
  }
  const data = overview.data!;
  const linkedMember: LinkedMember = {
    memberId: id!,
    memberName: data.profile.display_name ?? data.profile.email,
  };

  return (
    <>
      <Group mb="sm">
        <Anchor component={Link} to="/users" size="sm">
          ← All users
        </Anchor>
        {/* ASC-833: this member's feedback; the read is audited with them as its subject. The
            state names them on the Feedback screen's chip before any of their rows load. */}
        <Anchor
          component={Link}
          to={`/feedback?user_id=${encodeURIComponent(id!)}`}
          state={linkedMember}
          size="sm"
        >
          Feedback
        </Anchor>
      </Group>
      {/* A Grid inside main, not a second AppShell region, so the rail scrolls with
          the content. */}
      {/* No `gutter` prop: Mantine 9's Grid does not declare one (the plan assumed
          the v7 API). The default column spacing is what we want anyway. */}
      <Grid>
        <Grid.Col span={{ base: 12, md: 4, lg: 3 }}>
          <Stack gap="md">
            <LeftRail overview={data} />
            {/* SPRINT-0029 [8A-3] — this month's model spend against the member monthly cap. */}
            <UsagePanel usage={data.usage} />
          </Stack>
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 8, lg: 9 }}>
          <Timeline userId={id!} timezone={data.profile.user_timezone} />
        </Grid.Col>
      </Grid>
    </>
  );
}
